// extracted by mini-css-extract-plugin
export default {"applicationNumber":"InternalMessageFieldsAndAttachments_applicationNumber__EVB+u"};